export const allowedTypes = [String, Number, Date, Boolean];
export const bannedTypes = [Promise, Array, Object, Function];
